import { createAction } from 'redux-act';

import { Reservation } from '../../../models/interfaces/reservation/Reservation';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchReservationsPayload extends FetchPayload {
  placeUuid: string;
}
export const fetchReservations = createAction<FetchReservationsPayload>('FETCH_RESERVATIONS');
export interface ReservationsFetchedPayload extends TimestampPayload {
  placeUuid: string;
  reservations: Reservation[];
}
export const reservationsFetched = createAction<ReservationsFetchedPayload>('RESERVATIONS_FETCHED');

export interface ReservationsFetchFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const reservationsFetchFailed = createAction<ReservationsFetchFailedPayload>('RESERVATIONS_FETCH_FAILED');

export type ReservationsFetchResponsePayload = ReservationsFetchedPayload | ReservationsFetchFailedPayload;
